export const navLinks = [
  {
    label: 'Projects',
    pathname: '/',
    hash: '#project-1',
  },
  {
    label: 'Articles',
    pathname: '/articles',
  },
  {
    label: 'About',
    pathname: '/',
    hash: '#about',
  },
  {
    label: 'Contact',
    pathname: '/contact',
  },
];

export const socialLinks = [
  {
    label: 'LinkedIn',
    url: 'https://www.linkedin.com/in/syket-das-b6500b217',
    icon: 'linkedin',
  },
  {
    label: 'FaceBook',
    url: '/',
    icon: 'dribbble',
  },
  {
    label: 'Github',
    url: 'https://github.com/syket112',
    icon: 'github',
  },
];
